import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import Share from './components/Share'
import Debtor from './components/Debtor'

import './style.scss'

@hocBlock(config.modules.report.key, { levelReload: true })
export default class Liens extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
    }

    render() {
        const { id, block, module, data, level } = this.props

        return (
            <div className={'liens-block'}>
                <Share id={id} block={block} module={module} level={level} summaryData={_.get(data, '[0]', {})} />
                <Debtor id={id} block={block} module={module} level={level} summaryData={_.get(data, '[1]', {})} />
            </div>
        )
    }
}
